var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// ./~/node-libs-browser/~/isarray/index.js
// module id = 666
// module chunks = 1